'use client';

import { SidebarProvider } from '@/context/SidebarContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import React from 'react';
import AppContextProvider from './AppContextProvider';
import AppProgressProvider from './AppProgressProvider';
import ReactQueryProvider from './ReactQueryProvider';

export function Providers({
  children,
  session,
}: {
  children: React.ReactNode;
  session: Session | null;
}) {
  return (
    <ReactQueryProvider>
      <AppProgressProvider>
        <AppContextProvider value={{ session }}>
          <SessionProvider session={session}>
            <ThemeProvider>
              <SidebarProvider>{children}</SidebarProvider>
            </ThemeProvider>
          </SessionProvider>
        </AppContextProvider>
      </AppProgressProvider>
    </ReactQueryProvider>
  );
}
